import React, { useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import ZoneService from "../../../services/Zone";
import SocieteAndUserService from "../../../services/societeAndUser";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

const theSocieteIs = [
  { label: "FOURNISSEUR", value: 0 },
  { label: "CLIENT", value: 1 },
];
const convertir = (data) => {
  if (Array.isArray(data?.userResponse)) {
    return data.userResponse.map((user) => ({
      value: user.id,
      label: `${user.name.trim()} ${user.prenom.trim()}`, // Combine name and surname
    }));
  }
  return []; // Return an empty array if the data structure is invalid or not an array
};

const AddZone = () => {
  const navigate = useNavigate();
  const [showElement, setShowElement] = useState(
    JSON.parse(localStorage.getItem("status"))
  );
  const [societeLabel, setSocieteLabel] = useState([]);
  const [userList, setUserList] = useState([]);
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState("");
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState("");
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await SocieteAndUserService.getAllUserPartner(0);
        setUserList(convertir(response.data))
        console.log(convertir(response.data)); // or set it in state
        console.log((response.data)); // or set it in state

      } catch (error) {
        console.error("Error fetching user partners:", error);
      }
    };

    fetchData();
  }, []);


  const handleMultiSelectChange = (selectedOptions) => {
    setSocieteLabel(selectedOptions);
    console.log("Selected commerciaux:", selectedOptions);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason !== "clickaway") {
      setOpenSuccessAlert(false);
    }
  };

  const handleErrorClose = (event, reason) => {
    if (reason !== "clickaway") {
      setOpenErrorAlert(false);
    }
  };

  const onConfirmAddSocieteHandler = async () => {
    try {
      const result = societeLabel.map((item) => item.value);
      // Ensure `description` and `name` variables are defined
      if (!description || !name) {
        setErrorAlertText("Description and Name are required!");
        setOpenErrorAlert(true);
        return;
      }

      const data = {
        description,
        idUser: getCurrentUserId(),
        listUsers: result,
        name,
      };

      // Call the API
      await ZoneService.addZone(data);

      console.log("Confirmed data:", data);
      setOpenSuccessAlert(true);
      setSuccessAlertText("Zone added successfully!");
      navigate("/zone")
    } catch (error) {
      console.error("Error adding zone:", error);
      setErrorAlertText("Failed to add zone. Please try again.");
      setOpenErrorAlert(true);
    }
  };


  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Home</li>
                <li className="breadcrumb-item active">Ajouter zones</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title">Ajouter une zone</h5>
                </div>
                <div className="card-body">
                  <div className="row" style={{ marginTop: 10 }}>
                    {!showElement?.includes("USER_B2B") && (
                      <>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Nom de zone:</label>
                            <input
                              className="form-control"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Choisir Responsable:</label>
                            <Select
                              isMulti
                              options={userList}
                              value={societeLabel}
                              onChange={handleMultiSelectChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label>Description de zone:</label>
                            <textarea
                              className="form-control"
                              rows="3"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                            ></textarea>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="card-footer">
                  <button
                    className="btn btn-dark float-right"
                    onClick={onConfirmAddSocieteHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleErrorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleErrorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AddZone;
